<div class="fgbcl-game-predictor-result-answer-section">
  <ng-container *ngIf="question.AnswerDisplayType !== answerDisplayTypes.ImageAndText; else imageAndText">
    <div class="fgbcl-game-predictor-result-anwser-card">
      <div class="fgbcl-game-predictor-result-anwser-card-text">{{ 'fgbcl.game.predictor.you.guessed.text' | translate }}</div>
      <div class="fgbcl-game-predictor-result-answers fgbcl-game-predictor-guessed-answer">{{ selectedAnswer?.Title }}</div>
    </div>
    <div class="fgbcl-game-predictor-result-anwser-card">
      <div class="fgbcl-game-predictor-result-anwser-card-text">{{ 'fgbcl.game.predictor.correct.answer.text' | translate }}</div>
      <div class="fgbcl-game-predictor-result-answers fgbcl-game-predictor-correct-answer">{{ correctAnswer?.Title }}</div>
    </div>
  </ng-container>
  <ng-template #imageAndText>
    <div class="fgbcl-game-answer-type-image-and-text-container">
      <div class="fgbcl-game-predictor-result-anwser-card-text fgbcl-game-predictor-result-image-And-Text">
        {{ 'fgbcl.game.predictor.you.guessed.text' | translate }}
      </div>

      <div class="fgbcl-game-answer-image-section">
        <div>
          <img
            class="fgbcl-game-answer-image"
            [src]="selectedAnswer?.ImageUrl | contentImage: '7'"
            alt="{{ selectedAnswer?.Title }}"
          />
        </div>
        <div class="fgbcl-game-answer-text">{{ selectedAnswer?.Title }}</div>
      </div>
    </div>

    <div class="fgbcl-game-answer-type-image-and-text-container">
      <div class="fgbcl-game-answer-image-section">
        <div class="fgbcl-game-predictor-result-anwser-card-text fgbcl-game-predictor-result-image-And-Text">
          {{ 'fgbcl.game.predictor.correct.answer.text' | translate }}
        </div>
        <div>
          <img
            class="fgbcl-game-answer-image"
            [src]="correctAnswer?.ImageUrl | contentImage: '7'"
            alt="{{ correctAnswer?.Title }}"
          />
        </div>
        <div class="fgbcl-game-answer-text">{{ correctAnswer?.Title }}</div>
      </div>
    </div>
  </ng-template>
</div>
